var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RouteHandler from "../App/RouteHandler";
import { Translate } from "../I18N";
import { withRouter } from "../componentWrappers";
import auth from "../Auth";

class UnlockAccount extends RouteHandler {
  unlockAccount() {
    const { username, code } = this.props.params;
    this.props.
    unlockAccount({ username, code }).
    then(() => {
      this.props.navigate('/login');
    }).
    catch(() => {
      this.props.navigate('/login');
    });
  }

  componentDidMount() {
    this.unlockAccount();
  }

  render() {
    return /*#__PURE__*/(
      _jsx("div", { className: "content login-content" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "row" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "col-xs-12 col-sm-4 col-sm-offset-4 text-center" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Verifying...")
      )
      )
      ));

  }
}

UnlockAccount.propTypes = {
  unlockAccount: PropTypes.func,
  params: PropTypes.shape({
    username: PropTypes.string,
    code: PropTypes.string
  })
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      unlockAccount: auth.actions.unlockAccount
    },
    dispatch
  );
}

export { UnlockAccount };
export default connect(null, mapDispatchToProps)(withRouter(UnlockAccount));